export default __webpack_public_path__ + "static/media/distributor-marker.32102417.png";